import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';
import { RootState } from '../redux/store';
import { useRouteNavigator } from './useRouteNavigator';
import usePrepareLink from '../popups/hooks/usePrepareLink';
import { GET_ENUMS } from '../popups/router';
import { RouterParam } from '../helpers/routerParam';
import { isPhoneConfirmationRequired } from '@/helpers/sessionStorageService';

export function PhoneConfirmationRedirect() {
  const location = useLocation();
  const routeNavigator = useRouteNavigator();
  const loginInfo = useAppSelector((state: RootState) => state.customerState.loginInfo);

  const confirmPhoneLink = usePrepareLink({
    query: {
      [RouterParam.Popup]: GET_ENUMS.popup.confirmPhone,
    },
  });

  if (!loginInfo?.customers?.length) {
    return null;
  }

  if (!isPhoneConfirmationRequired() || loginInfo.phoneConfirmed) {
    return null;
  }

  const popup = new URLSearchParams(location.search).get(RouterParam.Popup);
  if (popup === GET_ENUMS.popup.confirmPhone) {
    return null;
  }

  return <Navigate to={{ pathname: routeNavigator.getHomePath(), search: confirmPhoneLink.search }} replace />;
}
